<template>
  <v-app id="simple">
    <v-app-bar dark app clipped-right color="primary">
      <v-container fluid class="py-0 fill-height">
        <v-spacer></v-spacer>
        <v-btn class="mr-2 primary" small @click="openPlanDialog" v-if="user">Plan: <b>{{
          user?.subscription?.plan?.product }}</b></v-btn>
        <v-btn small class="mr-5 orange d-none" to="/plans"
          sv-if="['free', 'trial'].includes(user?.subscription?.plan?.product)">
          
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{on, attrs}">
            <v-avatar v-bind="attrs" v-on="on" class="pointer primary lighten-1" size="32">
              <span>{{ user ? user.name.charAt(0).toUpperCase() : "M" }}</span>
            </v-avatar>
          </template>
          <v-list>
            <v-list-item to="/" v-if="!user">
              <v-list-item-title>{{ $t("search") }}</v-list-item-title>
            </v-list-item>
            <v-list-item to="/register" v-if="!user">
              <v-list-item-title>{{ $t("join") }}</v-list-item-title>
            </v-list-item>
            <v-list-item to="/login" v-if="!user">
              <v-list-item-title>{{ $t("login") }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="user">
              <v-list-item-title>{{ user.name || user.username }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openPlanDialog" v-if="user">
              <v-list-item-title>
                Plan: <b>{{ user?.subscription?.plan?.product }}</b>
              </v-list-item-title>
            </v-list-item>

            <v-list-item to="/logout" v-if="user">
              <v-list-item-title>{{ $t("logout") }}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <ChangeLanguage />
            </v-list-item>
          </v-list>
        </v-menu>
      </v-container>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
      <v-snackbar v-model="data.snackbar.visible" :color="data.snackbar.color">
        {{ data.snackbar.text }}
        <template v-slot:action="{attrs}">
          <v-btn :color="data.snackbar.buttonColor" text v-bind="attrs" @click="data.snackbar.visible = false">{{
            $t("close") }}</v-btn>
        </template>
      </v-snackbar>
      <v-dialog v-model="planDialog" max-width="700px">
        <v-card>
          <v-card-title class="headline"></v-card-title>
          <v-card-text>
            <div v-if="user?.subscription?.plan" class="plan-details">
              <v-card outlined>
                <v-card-title class="headline">{{ $t('subscription-details') }}</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="5">
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title><strong>{{ $t('product') }}:</strong></v-list-item-title>
                            <v-list-item-subtitle>{{ user.subscription.plan.product }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title><strong>{{ $t('status') }}:</strong></v-list-item-title>
                            <v-list-item-subtitle>{{ user.subscription.status }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title><strong>{{ $t('renewal-date') }}:</strong></v-list-item-title>
                            <v-list-item-subtitle>{{ user.subscription.end | FormatDateTimeLong
                              }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title><strong>{{ $t('limits') }}:</strong></v-list-item-title>
                            <v-list-item-subtitle>
                              <ul>
                                <li v-for="(value, key) in user.subscription.plan.limits" :key="key">
                                  {{ key | key2human | uppercase }}: <strong>{{ value }}</strong>
                                </li>
                              </ul>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title><strong>{{ $t('usage') }}:</strong></v-list-item-title>
                            <v-list-item-subtitle>
                              <ul>
                                <li v-for="(value, key) in user.subscription.usage" :key="key">
                                  {{ key | key2human | uppercase }}:
                                  <span>

                                    <span v-if="value > user.subscription.plan.limits[key]"
                                      style="color: red; font-weight: bold;">
                                      <strong>{{ user.subscription.plan.limits[key] }}</strong> ({{ $t('LIMIT REACHED')
                                      }})
                                    </span>
                                    <span v-else>
                                      <strong>{{ value }}</strong>
                                    </span>
                                  </span>


                                </li>
                              </ul>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
            <div v-else>
              <p>{{ $t('no-plan-details-available') }}.</p>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn text dark class="orange d-none" to="/plans"
              sv-if="['free', 'trial'].includes(user?.subscription?.plan?.product)">
              
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="planDialog = false">{{ $t("close") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
    <v-overlay :value="data.showMask" z-index="9999">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator"
import EventBus from "./../eventBus"
import ChangeLanguage from "./../libs/i18n/ChangeLanguage.vue"
import {config} from "@/libs/utils"
import {cacheSrv} from "@/libs/cache/cache"
import {subscriptionService} from "./../features/user/subscription-service"

@Component({
  components: {
    ChangeLanguage,
  },
})
export default class SimpleLayout extends Vue {
  subscriptionUpgradeUrl = config.VUE_APP_APP_PAYMENT_URL
  user: any = null
  planDialog = false

  data: any = {
    user: null,
    drawer: null,
    showMask: false,
    snackbar: {
      visible: false,
      text: "",
      buttonColor: "white",
    },
  }

  constructor() {
    super()
    this.user = this.$store.getters.profile
    this.init()
  }
  async init() {
    let userSubscription: any = await subscriptionService.loadSubscription()
    if (userSubscription) {
      Vue.set(this.user, "subscription", userSubscription.subscription)
    }
  }

  async openPlanDialog() {
    await this.refreshSubscriptionDetails()
    this.planDialog = true
  }

  async refreshSubscriptionDetails() {
    let userSubscription: any = await subscriptionService.loadSubscription()
    if (userSubscription) {
      Vue.set(this.user, "subscription", userSubscription.subscription)
    }
  }

  created() {
    EventBus.$on("display-snackbar", this.displaySnackbar)
    EventBus.$on("user-session-event", this.userSessionEvent)
    EventBus.$on("display-mask", this.showMask)
    EventBus.$on("hide-mask", this.hideMask)
  }

  beforeDestroy() {
    EventBus.$off("display-snackbar", this.displaySnackbar)
    EventBus.$off("user-session-event", this.userSessionEvent)
    EventBus.$off("display-mask", this.showMask)
    EventBus.$off("hide-mask", this.hideMask)
  }
  userSessionEvent(payload: any) {
    console.log("userSessionEvent: ", payload)
    Vue.set(this, "user", payload.user)
  }

  gotoUpgrade() {
    window.location.href = this.subscriptionUpgradeUrl
  }

  displaySnackbar(payload: any) {
    this.data.snackbar.visible = false // first close any open snackbar
    this.data.snackbar.text = payload.text
    this.data.snackbar.visible = true

    switch (payload.type) {
      case "success": {
        this.data.snackbar.color = "success"
        this.data.snackbar.buttonColor = "white"
        break
      }
      case "error": {
        this.data.snackbar.color = "error"
        this.data.snackbar.buttonColor = "white"
        break
      }
      case "warning": {
        this.data.snackbar.color = "warning"
        //this.data.snackbar.buttonColor = "white";
        break
      }
      case "info": {
        this.data.snackbar.color = "info"
        //this.data.snackbar.buttonColor = "white";
        break
      }
      default: {
        this.data.snackbar.color = "primary"
        this.data.snackbar.buttonColor = "white"
        break
      }
    }
  }

  showMask(show: boolean) {
    this.data.showMask = show
  }
  hideMask() {
    this.data.showMask = false
  }
}
</script>
